import { makeAutoObservable } from "mobx";

class TimelineStoreInstance {
  width = 0;
  tracksContainerWidth = 0;
  draggedClips: Record<string, true> = {};
  draggedLibrettoClips: Record<string, true> = {};
  draggedTransitions: Record<string, true> = {};
  zoom = 1;

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  setWidth(width: number) {
    this.width = width;
  }

  setTracksContainerWidth(width: number) {
    this.tracksContainerWidth = width;
  }

  setDraggingClip(clipId: string, isDragging: boolean) {
    if (isDragging) {
      this.draggedClips[clipId] = true;
    } else {
      delete this.draggedClips[clipId];
    }
  }

  // setDraggingLibrettoClip(librettoClipId: string, isDragging: boolean) {
  //   if (isDragging) {
  //     this.draggedLibrettoClips[librettoClipId] = true;
  //     // Also mark all associated rendley clips as dragging for backward compatibility
  //     const clipIds = RendleyStore.getClipIdsForLibrettoClip(librettoClipId);
  //     clipIds.forEach(clipId => {
  //       this.draggedClips[clipId] = true;
  //     });
  //   } else {
  //     delete this.draggedLibrettoClips[librettoClipId];
  //     // Remove all associated rendley clips from dragging
  //     const clipIds = RendleyStore.getClipIdsForLibrettoClip(librettoClipId);
  //     clipIds.forEach(clipId => {
  //       delete this.draggedClips[clipId];
  //     });
  //   }
  // }

  setDraggingTransition(transitionId: string, isDragging: boolean) {
    if (isDragging) {
      this.draggedTransitions[transitionId] = true;
    } else {
      delete this.draggedTransitions[transitionId];
    }
  }

  setZoom(zoom: number) {
    if (zoom < 0.1) {
      this.zoom = 0.1;
    } else if (zoom > 4) {
      this.zoom = 4;
    } else {
      this.zoom = zoom;
    }
  }

  reset() {
    this.width = 0;
    this.tracksContainerWidth = 0;
    this.draggedClips = {};
    this.draggedLibrettoClips = {};
    this.draggedTransitions = {};
    this.zoom = 1;
  }
}

const TimelineStore = new TimelineStoreInstance();

export { TimelineStore };
